
import { Component, Vue, Prop } from "vue-property-decorator";
import Purenavbar from "@/components/Utility/Purenavbar.vue";
import MobileQuestion from "@/components/MobileQA/MobileQuestion.vue";
import MobileAns from "@/components/MobileQA/MobileAns.vue";
import { MobileQaItem } from "@/models/QaAnswer";

@Component({
  components: {
    Purenavbar,
    MobileQuestion,
    MobileAns,
  },
})
export default class MobileQA extends Vue {
  @Prop() readonly question!: string | undefined;

  //data
  chooseQuestion = 0;
  questionVisible = true;
  answerVisible = false;
  // eslint-disable-next-line @typescript-eslint/ban-types
  MobileQAList: MobileQaItem[] = [
    {
      Question: "我有兩種不同的工項需求，是不是要下兩次單？",
      Ans: [
        "不需要，您可以選擇主要工項，在填寫訂單頁面「說明欄位」，描述另外需要的工項服務即可，師傅們將會依據您的需求來決定是否承接案件。",
      ],
    },
    {
      Question: "我可以先了解產品或服務的價格為何嗎？",
      Ans: [
        "您可以依照需求選擇服務工項，每個服務工項都有歷史價格區間範圍可以參考喔，讓您心裡有一個底。",
        "我們也會盡可能要求師傅報價落此價格區間範圍，但實際上仍會依照現場環境、品牌、型號等等有所差異喔。",
      ],
    },
    {
      Question:
        "為什麼下單時無法查看該區域所有師傅的資歷，讓我可以挑選喜歡的師傅？",
      Ans: [
        {
          list: "ol",
          items: [
            {
              title: "為了讓師傅配合您的時間。",
              body: [
                "師虎來了是最先進的即時修繕媒合共享平台，不同於傳統其它平台做法，我們平台採取即時媒合的方式，如同您叫計程車一樣，讓您在您需要的時間，就可以有在您附近且適合的師傅為您服務，而不是讓您去配合師傅的時間。",
              ],
            },
            {
              title: "嚴格篩選並持續考核師傅制度，盡可能維持五星師傅為您服務。",
              body: [
                "師虎的師傅除了需參加師虎舉辦的說明會之外，也必須通過我們一對一的面試，而我們錄取率只有36%，非常嚴謹篩選，即使加入成為師虎的夥伴後，我們的評鑑考核制度也不會停止。",
              ],
            },
          ],
        },

        "所以您不需費心自己挑選師傅，師虎的施工品質、師傅素質普遍都會比其他管道來的更好，並且完工後的售後保固服務皆由師虎平台負責，不會讓您曝露在挑選錯誤師傅的風險中。",
      ],
    },
    {
      Question: "請問你們的服務範圍為何？",
      Ans: [
        "目前西半部都有師傅可以承接案件，您可以參考我們官網上師傅分布的狀況，但可能會因各種類的師傅數量或是時間等等因素，發生某些地區雖然有師傅，但卻媒合不到師傅的情形。",
        "因此，師虎來了團隊持續會積極招募優質的師傅，讓每個地區的客戶都可以在想要的時間得到所需要的修繕服務。",
      ],
    },
    {
      Question: "沒有媒合成功，是不是要重新下單？",
      Ans: [
        "沒有媒合成功可能是因為您附近的可以承接的師傅們正在忙碌工作，沒辦法即時注意到您的訂單，又或是您預約的時間、工項剛好沒有師傅可以配合提供。",
        "您可以再次重新下單媒合看看，或是重新下單媒合後，點選「由專人協助媒合」按鍵，將會有專人為您協尋師傅處理您的訂單喔。",
      ],
    },
    {
      Question: "可以先讓師傅到我家估價嗎？",
      Ans: [
        "因為我們是共享媒合平台，所以我們提供的服務是讓優質的師傅在他閒暇的時間可以承接案件。",
        "因此，必須先請您下單，媒合成功後才能確定是由哪位師傅接單，師傅也會在您指定的時間前往勘查喔！",
        "媒合成功後，您需支付派遣費，師傅才會出發前往勘查，派遣費的詳細說明請見下方相關問題。",
      ],
    },
    {
      Question: "為何要支付派遣費？",
      Ans: [
        "每一位師傅至您府上勘查至少要花費1-2小時，包含通勤時間，油資，人力成本，專業技術以及平台的維運，若您不同意師傅報價，我們仍然會支付師傅車馬費用，讓他獲得應該有的報酬。",
      ],
    },
    {
      Question: "派遣費可以折抵施工費用嗎？",
      Ans: [
        "可以，當您同意師傅報價單，此筆派遣費是可以全額抵扣，但加成時段收取的派遣費，若施工費用低於加成金額，仍以加成金額計算，不會退還差額。",
      ],
    },
    {
      Question: "派遣費可以退嗎？",
      Ans: [
        "不行，我們是在媒合師傅成功後才會收取派遣費，代表您已經預約師傅的時間。但您最多可保留一個月時間，安排好時間後再重新預約下單。",
      ],
    },
    {
      Question: "派遣費是多少？任何時段都一樣嗎？",
      Ans: [
        "派遣費並非固定金額，會依您叫修的時段而不同，最低為 $300。",
        "派遣費依叫修時段分為五種：",
        {
          list: "ul",
          items: [
            "**一般時段**：週一至週五 AM8:00–PM5:59（不含國定假日、連續假日），**$300**",
            "**夜間加成**：週一至週五 PM6:00–PM8:59，**$2,500**",
            "**假日加成**：週六、週日 AM8:00–PM8:59，**$2,500**",
            "**國定假日／連續假日加成**：AM8:00–PM8:59，**$3,500**",
            "**特殊時段加成**：以上時段以外（如深夜、清晨），**$4,500**",
          ],
        },
        "若非緊急狀況，建議選擇一般時段叫修，可省下加成費用。《師虎Pro》會員的每年6次免派遣費優惠，也僅適用於一般時段，不適用加成時段。",
      ],
    },
    {
      Question: "請問派遣費會開發票嗎？",
      Ans: [
        "會，您在平台上所有支付的款項都會開立電子發票，並約2-3天寄送至您註冊時所填寫的郵件信箱，若沒收到您可試著在郵件中的垃圾桶看看，且包含後續的工程修繕款項都會開立發票！",
        "若您是公司行號需要報帳，可以在填寫訂單頁面下方輸入您的抬頭與統一編號。",
      ],
    },
    {
      Question: "請問如果我不知道怎麼選擇工項，我要如何下單？",
      Ans: [
        "如果您不知道如何選擇工項，您可以透過關鍵字搜尋看看，搜尋結果將會顯示所有相關的工項，您可以選擇最接近的工項，並且在訂單填寫頁面寫下您的狀況或是同時上傳照片，師傅會根據您寫的狀況來決定要不要接案。",
        "若您真的選不到任何您覺得相近的工項，您可以下單修繕顧問，並且於下單頁面寫下您的狀況描述，讓師虎的技術客服管理師來協助您做問題處理，謝謝您。",
      ],
    },
    {
      Question: "請問我要廚房跟浴室還有一些小局部翻新，我可以怎樣下單？",
      Ans: ["您可以下單兩個區域以上翻新，即可媒合師傅到您現場勘查報價喔。"],
    },
    {
      Question: "請問免設計圖客製施工是如何進行？",
      Ans: [
        "免設計圖客製施工主要是提供給一些對自己房屋改造有想法的客戶，又或是在預算比較侷限的客戶。",
        "這樣的案件會由專業的統包師傅團隊來做接案，他們可以依據跟您的討論內容提供報價單，並於施工過程中做監工確保施工的品質。",
        "師傅也會針對您的裝修修繕提供最專業的建議，承接統包案件的師傅都承接過相當多的設計施工案，您可參考師虎部落格中的客戶案例，也許多都是由統包師傅完成的個案，他們對實際施工技巧與工法都是相當了解，如果您想把繪製設計圖檔的費用節省下，這是您最佳的選擇。",
      ],
    },
    {
      Question: "如果我叫修後覺得師傅不滿意，我可以怎麼做？",
      Ans: [
        "您可以在您「進行中訂單」右上方跟師虎技術客服管理師做陳述，讓師虎技術客服管理師協助您與師傅溝通，亦或是在必要的情況下為您更換師傅，為您做好把關。",
      ],
    },
    {
      Question: "我想成為師虎來了的師傅，我可以怎樣參加呢？",
      Ans: [
        "您可以在我們官網上www.fdtigermaster.com 選擇您可以的場次，報名參加說明會，通過考核後，就可以在師虎來了平台上接案喔。",
      ],
    },
    {
      Question: "發票說明",
      Ans: [
        {
          subQa: "Q1：什麼是「電子發票」？",
          body: [
            "根據財政部令「電子發票實施作業要點」，在「師虎來了」平台上的消費將開立電子發票，不主動寄送紙本。",
            "「師虎來了」亦會將已開立發票號碼上傳至政府平台，並寄送電子發票開立通知信至用戶 Email 信箱，用戶可透過網路查詢發票明細。",
          ],
        },
        {
          subQa: "Q2：我怎麼知道發票有沒有中獎？",
          body: [
            "如您幸運中獎，若使用會員載具，您將會收到中獎通知 Email；若使用手機條碼載具或自然人憑證載具，將由財政部電子發票整合服務平台通知領獎相關訊息及作業。",
          ],
        },
        {
          subQa: "Q3：發票可以更換嗎？",
          body: [
            "發票一經開立後，恕無法更改。",
            "請於填寫叫修資訊時，仔細確認應取得之發票類型，「師虎來了」已盡告知義務，且為配合國稅局勸止換開發票之政策，本公司有權利考量各因素後拒絕換開發票，如您誤選請盡速與客服聯繫。",
          ],
        },
        {
          subQa: "Q4：如果發票開錯要怎麼處理？",
          body: [
            "如公司抬頭、統一編號錯誤需更改，請與客服聯繫。原始發票將作廢，為您重新開立發票，並將酌收發票處理手續費 105 元（含稅），處理時間為 10 個工作天。",
          ],
        },
        {
          subQa: "Q5：發票捐贈後，可以反悔不捐贈嗎？",
          body: [
            "發票一旦捐贈就不能反悔，其所有權即屬於受贈單位，亦不會通知用戶此發票是否中獎。",
          ],
        },
      ],
    },
    {
      Question: "《師虎 Pro》常見問題",
      Ans: [
        {
          subQa: "Q1：《師虎 Pro》是什麼？",
          body: [
            "是「師虎來了」在活動期間推出的專屬付費會員服務。 加入後可享有以下重點權益：",
            {
              list: "ul",
              items: [
                "修繕回饋： 首波享有修繕金4,000點回饋，可用於後續修繕費用全額折抵。",
                "免派遣費：提供終身享每年6次免收派遣費優惠。",
              ],
            },
            "【入會與使用規範】\n為確保所有會員享有公平且一致的服務體驗，平台採以下原則：",
            {
              list: "ol",
              items: [
                {
                  title: "會員權益適用時點",
                  body: [
                    "會員權益僅適用於「報價提出前」之新訂單。",
                    "凡案件已由師傅提供任何形式之報價（包含口頭、通訊訊息或系統報價），即視為已進入報價階段，該訂單不適用會員權益，且不得回溯適用。",
                  ],
                },
                {
                  title: "訂單獨立原則",
                  body: [
                    "針對既有案件（包含已進入報價階段之案件），不得透過關單、重新建立訂單或其他方式，回溯適用會員權益。",
                  ],
                },
                {
                  title: "同一案件認定機制",
                  body: [
                    "若訂單未完成施作關單，該修繕需求視為既有案件，自關單日起 滿1 個月 後，方得以新訂單重新提出，並適用會員權益。",
                    "於 1 個月期間內，針對同一修繕標的之需求，不得透過重新建立訂單等方式適用會員權益。",
                  ],
                },
              ],
            },
          ],
        },
        {
          subQa: "Q2：入會費用是多少？包含哪些優惠？",
          body: [
            "入會費用為 NT$2,000。成功加入後，您可以享有：",
            {
              list: "ul",
              items: [
                "首波享4,000 修繕金：可用於折抵工程尾款或商城消費。",
                "每年 6 次免派遣費：每一會員年度皆享有 6 次指定時段免收派遣費。",
                "終身會員身分：僅需支付一次入會費，即可持續保有 Pro 會員身分。",
              ],
            },
          ],
        },
        {
          subQa: "Q3：4,000 修繕金是現金嗎？可以怎麼使用？",
          body: [
            "修繕金為平台贈與之「優惠折抵額點數」，並非現金，且不可轉讓或提領。",
            {
              list: "ul",
              items: [
                "折抵範圍：可用於折抵「師虎來了」App 內之修繕工程尾款、指定商品消費。",
                "適用訂單：適用於尚未報價的訂單，以及升級後建立的新訂單；既有已報價訂單不適用，請於下一張訂單起使用。",
                "使用方式：於訂單支付尾款的頁面使用修繕金扣抵，並自由選擇欲折抵的點數。請於支付前確認是否折抵，付款後恕無法補折抵。",
              ],
            },
          ],
        },
        {
          subQa: "Q4：什麼是「每年 6 次免派遣費」？有什麼限制？",
          body: [
            "會員於每一會員年度內（自啟用日起算 365 日），享有 6 次免收派遣費之權益。",
            {
              list: "ul",
              items: [
                "限定一般時段：本優惠僅適用於 App 標示之「一般服務時段」。",
                "不適用範圍：夜間、凌晨、國定假日、連續假期或天災停班日等特殊時段。",
              ],
            },
            "費用說明：本優惠僅減免「派遣服務費」，不包含實際產生的工料費或特殊時段之加成費用。",
          ],
        },
        {
          subQa: "Q5：免派遣費次數沒用完，可以累積到明年嗎？",
          body: [
            "不可以。 每年的 6 次免派遣費額度僅限於當年度內使用。未使用完畢之次數將於年度屆滿（365 日）時自動歸零，並重新發放新一年度的 6 次額度。",
          ],
        },
        {
          subQa: "Q6：「終身會員身分」是什麼意思？",
          body: [
            "指您只需支付一次入會費，於本平台營運存續期間內，您的帳號將持續標記為 Pro 會員，無須每年重複繳納入會費。",
            "提醒：終身身分係指「身分資格」，不代表所有優惠內容（如免派次數、折抵比例）永久不變，平台得依營運需求調整權益並公告之。",
          ],
        },
        {
          subQa: "Q7：《師虎 Pro》會員可以轉讓或共用帳號嗎？",
          body: [
            "嚴格禁止。 本服務採「帳號專屬制」，僅限登記之會員本人使用。",
            {
              list: "ul",
              items: [
                "防弊機制：系統會自動監測登入裝置與叫修行為。若偵測到帳號共用、轉借他人或異常多點登入，平台有權暫停或終止該帳號權益。",
                "職業用戶：可為受託管理之物件代為叫修，但仍須由會員本人操作帳號，不得將帳號提供給客戶登入。",
              ],
            },
          ],
        },
        {
          subQa: "Q8：如果預約師傅後我臨時不在家，會扣次數嗎？",
          body: [
            "會。 為尊重師傅派遣成本，若師傅已接單出發，但因會員提供地址錯誤、無人應門或臨時取消，該次免派遣費優惠將視同已使用。請於下單前確認有人可配合現場勘查。",
          ],
        },
        {
          subQa: "Q9：購買後如果反悔，可以申請退費嗎？",
          body: [
            "退費標準依據《消費者保護法》與平台服務條款辦理：",
            {
              list: "ul",
              items: [
                "全額退費：購買後 7 日內，且完全未使用過任何權益（含領取修繕金、實際叫修）。",
                "比例退費：購買逾 7 日或已使用部分權益者，申請退費時須扣除行政規費（NT$300）、已領取點數及已使用之優惠價值。若剩餘價值為負數，則不予退費。",
              ],
            },
          ],
        },

        " 法律提醒 本 FAQ 頁面僅為簡要說明，旨在協助理解方案內容。詳細權利義務與限制，請務必參閱 《師虎 Pro 會員服務條款》 全文。",
      ],
    },
  ];

  mounted() {
    // body 底色改為 QA 頁面底色（樣式見 QA.scss 的 body.qa-body），內容較短時下方不露出白底
    document.body.classList.add("qa-body");

    if (!this.question) return;
    if (this.question === 'invoice') {
      this.openQuestion('發票說明');
      return;
    }
    if (this.question === 'pro') {
      this.openQuestion('《師虎 Pro》常見問題');
      return;
    }

    this.$router.replace({ path: '*' });
  }

  beforeDestroy() {
    document.body.classList.remove("qa-body");
  }

  openQuestion(title: string) {
    const index = this.MobileQAList.findIndex(q => q.Question === title);
    if (index === -1) return;
    this.chooseQuestion = index;
    this.questionVisible = false;
    this.answerVisible = true;
    this.$router.replace({ path: '/MobileQA' });
  }

  //computed
  get AnswerList() {
    return this.MobileQAList[this.chooseQuestion];
  }
  //methods
  getIndex(e: any): void {
    let index = e.target.getAttribute("index");
    this.chooseQuestion = index;
    this.questionVisible = false;
    this.answerVisible = true;
  }
  back(): void {
    this.questionVisible = true;
    this.answerVisible = false;
    if (this.$route.path !== '/MobileQA') {
      this.$router.push({ path: '/MobileQA' });
    }
  }
}
